
const documentRequestTypes = {
    EW_DOCUMENTS:0,
    ORGANISATION_DOCUMENTS:1,
}

export default documentRequestTypes;